import { Pipe, PipeTransform, inject } from '@angular/core';
import { StaticDataService } from '@mavles/shared';

@Pipe({
    name: 'contactType',
    standalone: false
})
export class ContactTypePipe implements PipeTransform {
  private staticDataService = inject(StaticDataService);


  transform(value: unknown): any {
    return  this.staticDataService.appConfig.contactTypes.find(t => t.contact_type_id === value)?.contact_type_name;
  }

}


